<template>
    <div class="aba-cliente">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns is flex-wrap">
                <div class="column" :class="[permissaoVincular ? 'is-6' : 'is-8']">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-limite-credito"
                    />
                </div>
                <div class="column" :class="[permissaoVincular ? 'is-3' : 'is-4']">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalCadastroLimiteCredito"
                    >
                        {{ $t('adicionar-limite-credito') }}
                    </button>
                </div>
            </div>
            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="limiteCreditoList"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !limiteCreditoIntegracao"
                                class="action-button"
                                :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'empresa'">
                            <a
                                @click="selectedEdit(props.row)"
                                v-if="permissao.update && !limiteCreditoIntegracao"
                            >
                                {{ props.row[f.key] }}
                            </a>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </div>
                        <div
                            v-else-if="
                                f.key == 'creditoliberado' ||
                                f.key == 'saldodevedor' ||
                                f.key == 'limitebonificacao'
                            "
                        >
                            {{ prefix }} {{ props.row[f.key] | decimal(2) }}
                        </div>
                        <div v-else-if="f.key == 'limitebonificacaop'">
                            {{ props.row[f.key] | decimal(2) }} %
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
            <!-- MODAL DE CADASTRO LIMITE DE CREDITO -->
            <b-modal :active.sync="showModalCadastro">
                <div>
                    <LimiteCreditoCadastroModal
                        @fecharModal="fecharModal"
                        @cadastrado="cadastrado"
                        :idCliente="+$route.params.id"
                        :idsaldocliente="+idsaldocliente"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
//SERVICES
import LimiteCreditoClienteService from '@/services/vendas/cliente/abas/LimiteCreditoClienteService';
import LimiteCreditoCadastroModal from '@/components/vendas/cliente/modal/LimiteCreditoCadastroModal';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

/* @71021 */
export default {
    components: {
        ContainerLoader,
        LimiteCreditoCadastroModal,
    },
    data() {
        return {
            limiteCreditoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'SALDOCLIENTE'
            ),
            permissao: false,
            limiteCreditoList: [],
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'empresa', width: null, sortable: true, sortFn: null },
                { key: 'creditoliberado', width: null, sortable: true, sortFn: null },
                { key: 'saldodevedor', width: null, sortable: true, sortFn: null },
                { key: 'limitebonificacao', width: null, sortable: true, sortFn: null },
                {
                    key: 'limitebonificacaop',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new LimiteCreditoClienteService(this.$http, this.$router),
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'limite-credito',
            order: 'asc',
            delete: null,
            showModalCadastro: false,
            idsaldocliente: 0,
            permissaoVincular: false,
            prefix: this.$store.state.empresas.data[0].simbolomonetario,

            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-politica-comercial-limite-credito'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-politica-comercial-limite-credito'
            );
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();

            this.permissaoVincular = this.permissao.create && !this.limiteCreditoIntegracao;
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.limiteCreditoList = Object.assign([], value);
                    this.isEmpty = this.limiteCreditoList.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as tabelas de limite de crédito');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idcliente, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    idsaldocliente: m.idsaldocliente,
                    idcliente: m.idcliente,
                    idempresa: m.idempresa,
                    creditoliberado: m.creditoliberado,
                    saldodevedor: m.saldodevedor,
                    limitebonificacao: m.limitebonificacao,
                    limitebonificacaop: m.limitebonificacaop,
                    'data-hora': m.datahorainc,
                    situacao: m.situacao,
                    codigo: m.empresa.idempresaerp,
                    empresa: m.empresa.nome,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['empresa'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-erro-ao-reativar-associacao-limite-credito'
                    : 'msg-erro-ao-desativar-associacao-limite-credito';

            let tempLimiteCredito = {
                idsaldocliente: this.delete.idsaldocliente,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };
            this.isLoading = true;
            this.updateSituacao(tempLimiteCredito)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-limite-credito'
                                : 'msg-sucesso-ao-desativar-limite-credito';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(limiteCredito) {
            if (this.isVenda) return this.service.updateSituacaoVendas(limiteCredito);
            else return this.service.updateSituacaoAgro(limiteCredito);
        },
        showModalCadastroLimiteCredito() {
            this.idsaldocliente = 0;
            this.showModalCadastro = !this.showModalCadastro;
        },
        fecharModal() {
            this.showModalCadastro = false;
            this.carregarDados();
        },
        cadastrado() {
            this.showModalCadastro = false;
            this.carregarDados();
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        },
        selectedEdit(selected) {
            this.idsaldocliente = selected.idsaldocliente;
            this.showModalCadastro = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
